export function picksector(data, sekt, subsekt = "_sum") {
  let tCO2 = data.municipality.budget.sector[sekt];
  let year = data.municipality.budget.year;
  let emissions_sector = data.municipality.emissions[sekt][subsekt];
  let budget_sector = { tCO2: tCO2, year: year };
  return [emissions_sector, budget_sector];
}

function sectornames_sorted(data, year = 2017) {
  //returns arrays of names (in order sorted by emission)
  //so sorted is just sectornames
  //and subsorted[sector] is subsectornames for that sector
  //year is which year to look at when sorting. 2017 is latest year with data so use that as default
  let emissions = {};
  let subsorted = {};
  for (let sekt in data.municipality.emissions) {
    if (sekt !== "_sum" && sekt !== "_rest") {
      emissions[sekt] = singlesectoremission(data, sekt, year);

      let subemissions = {};
      for (let subsekt in data.municipality.emissions[sekt]) {
        if (subsekt !== "_sum" && subsekt !== "_rest") {
          subemissions[subsekt] = singlesubsectoremission(
            data,
            sekt,
            subsekt,
            year
          );
        }
      }
      subsorted[sekt] = Object.keys(subemissions).sort((a, b) => {
        return subemissions[b] - subemissions[a];
      });
    }
  }
  let sorted = Object.keys(emissions).sort((a, b) => {
    return emissions[b] - emissions[a];
  });

  return [sorted, subsorted];
}

function largestsectoremission(data, year) {
  let emissions = [];
  for (let sekt in data.municipality.emissions) {
    if (sekt !== "_sum" && sekt !== "_rest") {
      emissions.push(singlesectoremission(data, sekt, year));
    }
  }
  return Math.max(...emissions);
}

function sumsectoremission(data, sekt, currentyear) {
  //sums from firstyear up until "currentyear"
  //so 2020 would give 2000-2019 inclusive in the vein of scenariotrack et al.
  //assumes data has been imputed
  let firstdatayear = data.years[0];
  let sum = 0;
  for (let i = 0; i < currentyear - firstdatayear; i++) {
    sum += data.municipality.emissions[sekt]["_sum"][i];
  }
  return sum;
}

function sumsubsectoremission(data, sekt, subsekt, currentyear) {
  //sums from firstyear up until "currentyear"
  //so 2020 would give 2000-2019 inclusive in the vein of scenariotrack et al.
  //assumes data has been imputed
  let firstdatayear = data.years[0];
  let sum = 0;
  for (let i = 0; i < currentyear - firstdatayear; i++) {
    sum += data.municipality.emissions[sekt][subsekt][i];
  }
  return sum;
}

function singlesectoremission(data, sekt, year, wholecountry = false) {
  let firstdatayear = data.years[0];
  //assumes data has been imputed
  if (wholecountry) {
    return data.country.emissions[sekt]["_sum"][year - firstdatayear];
  }
  return data.municipality.emissions[sekt]["_sum"][year - firstdatayear];
}

function singlesubsectoremission(
  data,
  sekt,
  subsekt,
  year,
  wholecountry = false
) {
  let firstdatayear = data.years[0];
  //assumes data has been imputed
  if (wholecountry) {
    return data.country.emissions[sekt][subsekt][year - firstdatayear];
  }
  return data.municipality.emissions[sekt][subsekt][year - firstdatayear];
}

export default {
  sectornames_sorted,
  largestsectoremission,
  sumsectoremission,
  sumsubsectoremission,
  singlesectoremission,
  singlesubsectoremission,
  picksector,
};
